export enum PaymentTypeEnum {
  DEAL = "DEAL",
  INVOICE = "IVOICE"
}
